@if(searchType < 3){ <section class="row my-3">

    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 mt-2">
        Cobertura
        <ng-select [(ngModel)]="coverageSelected" [items]="listCoverages" bindValue="_id" bindLabel="name"></ng-select>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 mt-2">
        Mes <small class="text-danger"></small>
        <input type="month" class="form-control" name="dateSince" [(ngModel)]="dateSince" min="2025-11"
            [max]="actualMonth" placeholder="Seleccione...">
    </div>
    <div class="col-xl-4 col-lg-6 col-sm-12 mt-4 d-flex align-items-center justify-content-center justify-content-xl-start gap-2 flex-wrap">
            <button [disabled]="!coverageSelected" class="btn btn-sm btn-primary" (click)="getPayrolls()"><i
                    class="fas fa-search"></i> Buscar</button>
            @if (dateSince !== '2025-11' && canGenerate) {
            <button [disabled]="!coverageSelected" class="btn btn-sm btn-outline-success" (click)="getUF()"><i
                    class="fas fa-users-gear"></i> Generar Nómina</button>
            }
    </div>

    </section>
    }


    @if(searchType == 1 && listPoliciesByCoverages?.length> 0){
    <hr>
    <section class="row my-3">
        <span class="fs-4 fw-500 mb-3">Resultados de la búsqueda</span>
        <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th>N°</th>
                        <th>Póliza</th>
                        <th>Nombre</th>
                        <th class="text-center">N° Registros</th>
                        <th class="text-center">Total UF</th>
                        <th class="text-center">Total Vida</th>
                        <th class="text-center">Total Salud</th>
                        <th class="text-center">Total $</th>
                        <th colspan="2" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(d of listPoliciesByCoverages; track d; let i = $index){
                    <tr class="text-nowrap" >
                        <td>{{i + 1}}</td>
                        <td>{{d.policy.code}}</td>
                        <td>{{d.policy.entity.name}}</td>
                        <td class="text-center">{{d.count}}</td>
                        <td class="text-center">{{d.sumaTotalUF | numberPipe: '0.0-4' }}</td>
                        <td class="text-center">{{d.sumaTotalVida | numberPipe: '0.0-0' }}</td>
                        <td class="text-center">{{d.sumaTotalSalud | numberPipe: '0.0-0' }}</td>
                        <td class="text-center">{{d.sumaTotalPesos | numberPipe: '0.0-0' }}</td>
                        <td>
                            <button class="btn btn-xs btn-info" (click)="getByEntity(d.policy.entityId, d.policyId)"><i
                                    class="fas fa-eye" ngbTooltip="Visualizar por campo / institución"
                                    placement="left"></i></button>


                        </td>
                        <td>
                            <button class="btn btn-xs btn-info" (click)="getByPolicy(d.policyId)"><i class="fas fa-list"
                                    ngbTooltip="Detalle nómina" placement="left"></i></button>
                        </td>
                    </tr>
                    }
                </tbody>


            </table>
        </div>

    </section>
    }

    @if(searchType == 2 && listPayrolls?.length > 0){
    <section class="row my-3">
        <span class="fs-4 fw-500 mb-3">Resultados de la búsqueda</span>
        <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th>N°</th>
                        <th>Póliza</th>
                        <th>Nombre</th>
                        <th class="text-center">Campo</th>
                        <th class="text-center">N° Registros</th>
                        <th class="text-center">Total UF</th>
                        <th class="text-center">Total Vida</th>
                        <th class="text-center">Total Salud</th>
                        <th class="text-center">Total $</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(d of listPayrolls; track d; let i = $index){
                    <tr class="text-nowrap" >
                        <td>{{i + 1}}</td>
                        <td>{{d["policy.code"]}}</td>
                        <td>{{d["group.campus.name"]}}</td>
                        <td>{{d["group.campus.acronym"]}}</td>
                        <td class="text-center">{{d.count}}</td>
                        <td class="text-center">{{d.sumaTotalUF | numberPipe: '0.0-4' }}</td>
                        <td class="text-center">{{d.sumaTotalVida | numberPipe: '0.0-0' }}</td>
                        <td class="text-center">{{d.sumaTotalSalud | numberPipe: '0.0-0' }}</td>
                        <td class="text-center">{{d.sumaTotalPesos | numberPipe: '0.0-0' }}</td>
                        <td>
                            <button class="btn btn-sm btn-info" (click)="getByPolicyAndCampus(d)"><i
                                    class="fas fa-list" ngbTooltip="Ver detalle nómina" placement="top"></i></button>
                        </td>
                    </tr>
                    }
                </tbody>


            </table>
        </div>

    </section>
    }


    @if(searchType == 3){
    <div class="card border-0 mb-4">

        <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <div class="col-md-8">
                <span class="fs-4 fw-500 ">Listado de la Nómina: <strong>{{payrollSel.policy.code}}</strong>, Periodo:
                        <strong>{{payrollSel.period | date: "MM-yyyy": "UTC"}}</strong></span>
                <button type="button" class="btn btn-primary-outline btn-sm mx-3" [ngbTooltip]="tooltipContent"
                    container="body" placement="bottom">* Mostrar simbologia</button>
            </div>
            <div class="col-md-4 d-flex justify-content-end">
                <button class="btn btn-success btn-xs border-0 mx-3" (click)="getPayrolls()"> <i
                        class="fas fa-arrow-left"></i> Volver </button>
                <button class="btn btn-white btn-sm border-0 text-gray" (click)="exportExcel()"> <i
                        class="fas fa-file-excel text-green"></i> Exportar </button>


            </div>

        </div>
    </div>
    <section class="row my-3">


        <div class="row">
            <div class="col-md-6 my-3">
                <input type="text" class="form-control" [(ngModel)]="find" (keyup)="filterSearch()"
                    (keyup.enter)="filterSearch()" placeholder="Ingrese el nombre del empleado/obrero">
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th>N°</th>
                        <th>Nombre Completo</th>
                        <th class="text-center">Cargas</th>
                        <th class="text-center">Edad</th>
                        <th class="text-center">RUT</th>
                        <th class="text-center">Asegurado</th>
                        <th class="text-center">Póliza</th>
                        <th class="text-center">Grupo</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center">Capital</th>
                        <th class="text-center">Total UF</th>
                        <th class="text-center">Total $</th>
                        <th class="text-center"><i class="fa fa-cogs"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @for(d of listPayrolls; track d; let i = $index){
                    <tr class="text-nowrap" [ngClass]="rowClass(d)">
                        <td>{{i + 1}}</td>
                        @if(d.relationship.code == "T"){
                        <td><strong>{{d.insured.names?.toUpperCase()}} {{d.insured.surname?.toUpperCase()}}
                                {{d.insured.lastname?.toUpperCase()}}</strong></td>
                        }@else {
                        <td>{{d.insured.names}} {{d.insured?.surname}} {{d.insured?.lastname}}</td>
                        }
                        <td class="text-center">{{d.coveredLives < 0 ? 'NV' : d.coveredLives}}</td>
                        <td class="text-center">{{d.insured.age}}</td>
                        <td class="text-center">{{d.insured.rut | numberPipe}}-{{d.insured.dv}}</td>
                        <td class="text-center">{{d.relationship.name }}</td>
                        <td class="text-center">{{d.policy?.code}}</td>
                        <td class="text-center">{{d.group?.name}}</td>
                        <td class="text-center">
                            @if(d.dateFinish){
                            <span
                                class="btn badge btn-outline-danger text-danger bg-white d-inline-flex align-items-center rounded btn-xs">
                                <i class="fas fa-circle mt-1 mr-2"></i> &nbsp; No Vigente</span>
                            }@else{
                            <span
                                class="btn badge btn-outline-success text-success bg-white d-inline-flex align-items-center rounded btn-xs">
                                <i class="fas fa-circle mt-1 mr-2"></i> &nbsp; Vigente</span>
                            }
                        </td>
                        <td class="text-center">{{d.capital | numberPipe}}</td>
                        <td class="text-center">{{d.totalUF | numberPipe: '0.0-4' }}</td>
                        <td class="text-center">{{d.totalPesos | numberPipe: '0.0-0'}}</td>

                        <td>
                            <button (click)="openContract(modalContract, d)" class="btn btn-info btn-xs">
                                <i class="fas fa-eye"></i></button>&nbsp;
                            @if(d.requestId){
                            <button class="btn btn-success btn-xs text-white"
                                (click)="openRequest(modalRequest, d.requestId)" ngbTooltip="Solicitud" placement="left">
                                <i class="fas fa-receipt"></i>
                            </button>
                            }

                        </td>
                    </tr>
                    }
                </tbody>


            </table>
        </div>

    </section>
    }



    <ng-template #modalContract let-c="close" let-d="dismiss">
        <app-review-payroll [contractSel]="contractSel"></app-review-payroll>
        <div class="modal-footer">
            <button class="btn btn-sm btn-danger m-r-1" (click)="d('Cross click')">Cerrar</button>
        </div>
    </ng-template>

    <ng-template #modalRequest let-c="close" let-d="dismiss">
        <app-review-request [requestId]="requestSel" [showHeader]="true" [showFooter]="false"></app-review-request>
        <div class="modal-footer">
            <button class="btn btn-sm btn-danger m-r-1" (click)="d('Cross click')">Cerrar</button>
        </div>
    </ng-template>

    <ng-template #tooltipContent>
        <table class="table table-bordered bg-white">
            <thead>
                <th>Color</th>
                <th>Referencia</th>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td>Sin Cambios</td>
                </tr>
                <tr>
                    <td class="table-warning"></td>
                    <td>Traspaso de Póliza</td>
                </tr>
                <tr>
                    <td class="table-success"></td>
                    <td>Cambio de Grupo</td>
                </tr>
                <tr>
                    <td class="table-danger"></td>
                    <td>Exclusion / Baja</td>
                </tr>
                <tr>
                    <td class="table-primary"></td>
                    <td>Ingresos</td>
                </tr>
                <tr>
                    <td class="table-secondary"></td>
                    <td>Modificación de Capital</td>
                </tr>
                <tr>
                    <td class="bg-pink-100"></td>
                    <td>Mayor 65 años</td>
                </tr>
            </tbody>
        </table>
    </ng-template>